<template>
  <v-navigation-drawer
    v-model="$root.sidebar"
    absolute
    temporary
  >
    <v-list
      nav
      dense
    >
      <v-list-item-group
        active-class="primary--text text--accent-4"
      >
        <v-list-item to="/dashboard/devs">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Developers</v-list-item-title>
        </v-list-item>

        <v-list-item to="/dashboard/djinni">
          <v-list-item-icon>
            <v-icon>mdi-robot</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Djinni (Mimiron)</v-list-item-title>
        </v-list-item>

        <v-list-item to="/dashboard/clients">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Clients</v-list-item-title>
        </v-list-item>

        <v-list-item to="/dashboard/salary">
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Salary</v-list-item-title>
        </v-list-item>

        <v-list-item to="/dashboard/jobs">
          <v-list-item-icon>
            <v-icon>mdi-briefcase</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Jobs</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {

}
</script>

<style>

</style>